import { create } from "zustand";
import MapboxViewer from "@/components/mapbox/MapboxViewer";
import { MapProjection } from "@/types/enum";
import type { MapboxCustomObject } from "@/components/mapbox/Lib/Objects/MapboxCustomObject";
// import type { MapboxContextMenu } from "@/components/types/app";
interface MapboxState {
  mapboxViewer: MapboxViewer | null;
  mapProjection: MapProjection;
  mapStyle: string;
  hoverFeature: MapboxCustomObject | null;

  isShadowMode: boolean;
  setIsShadowMode: (isShadowMode: boolean) => void;

  /** 0-100 while the simshady mesh is computing, null when idle/done. */
  shadowMeshProgress: number | null;
  setShadowMeshProgress: (progress: number | null) => void;

  // contextMenu: MapboxContextMenu | null;
  setMapViewer: (map: MapboxViewer | null) => void;
  setMapProjection: (projection: MapProjection) => void;
  setHoverFeature: (feature: MapboxCustomObject | null) => void;
  setMapStyle: (style: string) => void;
  // setContextMenu: (menu: MapboxContextMenu | null) => void;
  resetMapboxState: () => void;
}

const initialState = {
  mapboxViewer: null,
  mapProjection: MapProjection.Mercator,
  hoverFeature: null,
  isShadowMode: false,
  shadowMeshProgress: null as number | null,
  contextMenu: null,
  mapStyle: "streets-v12",
};

const useMapboxStore = create<MapboxState>()((set) => ({
  ...initialState,
  setIsShadowMode: (isShadowMode: boolean) => {
    set({ isShadowMode });
  },
  setShadowMeshProgress: (progress: number | null) => {
    set({ shadowMeshProgress: progress });
  },
  setMapProjection: (projection: MapProjection) => {
    set({ mapProjection: projection });
  },
  setMapViewer: (map: MapboxViewer | null) => {
    set({ mapboxViewer: map });
  },
  setHoverFeature: (feature: MapboxCustomObject | null) => {
    set({ hoverFeature: feature });
  },
  setMapStyle: (style: string) => {
    set({ mapStyle: style });
  },
  // setContextMenu: (menu: MapboxContextMenu | null) => {
  //   set({ contextMenu: menu });
  // },
  resetMapboxState: () => {
    set(initialState);
  },
}));

export default useMapboxStore;
